// Mounts the platform-provided notification-list route config at /notifications.

import { notificationListRoute } from '@podium/platform/routes'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/notifications')(notificationListRoute)
